var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-group accordion-local" },
    _vm._l(_vm.content, function(accordion, index) {
      return _c("div", { staticClass: "accordion accordion--desktop" }, [
        _c(
          "div",
          {
            staticClass:
              "accordion-title accordion-title--desktop collapsed text-uppercase",
            attrs: {
              "data-toggle": "collapse",
              "data-target": "#" + _vm.prefix + "-" + index,
              "aria-controls": _vm.prefix + "-" + index
            }
          },
          [_vm._v("  " + _vm._s(accordion.title) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "accordion-content accordion-content--desktop collapse flex-grow-1",
            attrs: { id: _vm.prefix + "-" + index }
          },
          [
            accordion.image
              ? _c("img", {
                  attrs: {
                    src: accordion.image.src,
                    alt: "",
                    width: accordion.image.width
                      ? accordion.image.width
                      : "100%"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "text-align-left",
              domProps: { innerHTML: _vm._s(accordion.content) }
            })
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf5c5ba", { render: render, staticRenderFns: staticRenderFns })
  }
}